export default "__VITE_ASSET__dd908a4a__"